import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "status-marker-icon",
  viewBox: "0 0 13 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M6.52179 6.42419C7.07407 6.42419 7.52179 5.97648 7.52179 5.42419C7.52179 4.87191 7.07407 4.42419 6.52179 4.42419C5.9695 4.42419 5.52179 4.87191 5.52179 5.42419C5.52179 5.97648 5.9695 6.42419 6.52179 6.42419Z" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.49982 0.447021C3.76455 0.447021 1.54718 2.66439 1.54718 5.39966C1.54718 6.63512 2.20852 7.81755 2.92838 8.75784C3.66425 9.71904 4.55223 10.5437 5.18511 11.0802L5.19695 11.09C5.95627 11.7074 7.04457 11.7074 7.80389 11.09L7.816 11.0799C8.44813 10.5435 9.33577 9.71894 10.0715 8.75778C10.7911 7.81753 11.4525 6.6351 11.4525 5.39966C11.4525 2.66439 9.23508 0.447021 6.49982 0.447021ZM3.04718 5.39966C3.04718 3.49282 4.59298 1.94702 6.49982 1.94702C8.40666 1.94702 9.95245 3.49282 9.95245 5.39966C9.95245 6.13166 9.54031 6.9838 8.88032 7.84607C8.23893 8.68404 7.44454 9.42732 6.85265 9.93014C6.64644 10.094 6.35425 10.094 6.14808 9.93005C5.55572 9.42734 4.76098 8.68403 4.11942 7.84601C3.45931 6.98377 3.04718 6.13164 3.04718 5.39966Z"
    }, null, -1)
  ])))
}
export default { render: render }